import React from 'react'
import {
    useModalDemand,
    useNotShipmentSelected,
    useResetSelectedGood,
    useSelectedBasketGood
} from 'src/features/add-basket/hooks'
import ModalWindow from '@shared/ModalWindow/ModalWindow'
import Button from '@shared/Button/Button'
import * as Theme from '@styles/theme-const'
import {
    useAddGoodBasket,
    useApplyConfirmationDelete,
    useCancelConfirmationDelete,
    useDeleteConfirmationGoodId
} from '@entities/basket/hooks'
import ModalWindowCustom from '@shared/ModalWindowCustom/ModalWindowCustom'
import * as S from './styled'
import { ModalsCatalog } from '@entities/basket/ui'
import { useToggleAddressSelector, useToggleStockSelector } from 'src/features/shipment-selector/hooks'
import { MessageSelectShipmentMobile } from '@mobileComponents/catalog/MessageSelectShipment/MessageSelectShipmentMobile'

const ModalIsNotShipmentFooter = () => {
    const toggleStockSelector = useToggleStockSelector()
    const toggleAddressSelector = useToggleAddressSelector()
    const good = useSelectedBasketGood()
    const addBasket = useAddGoodBasket()
    return (
        <S.ModalIsNotShipmentFooter>
            <S.ModalIsNotShipmentFooterButtons>
                <Button
                    data-selected="stock"
                    elementSizeTypeValue={Theme.ElementSizeType.regular}
                    clickHandler={toggleStockSelector}>
                    Выбрать аптеку самовывоза
                </Button>
                <Button
                    data-selected="address"
                    elementSizeTypeValue={Theme.ElementSizeType.regular}
                    clickHandler={toggleAddressSelector}>
                    Выбрать адрес доставки
                </Button>
                <Button
                    data-selected="cancel"
                    elementSizeTypeValue={Theme.ElementSizeType.regular}
                    clickHandler={() => addBasket(good)}>
                    Сделать выбор позже
                </Button>
            </S.ModalIsNotShipmentFooterButtons>
        </S.ModalIsNotShipmentFooter>
    )
}

export const AddBasketModals = () => {
    const modalDemand = useModalDemand()
    // const closeBasketDemand = useCloseBasketDemand()
    const isNotShipmentSelected = useNotShipmentSelected()
    const resetSelectedGood = useResetSelectedGood()
    const good = useSelectedBasketGood()
    const addBasket = useAddGoodBasket()
    return (
        <React.Fragment>
            <ModalsCatalog />
            {modalDemand.isShowed && (
                <ModalWindow
                    title="Внимание"
                    submit={{
                        text: 'Добавить в корзину',
                        clickHandler: () => addBasket(good)
                    }}
                    cancel={{
                        text: 'Отмена',
                        clickHandler: resetSelectedGood
                    }}>
                    <S.BodyModel
                        dangerouslySetInnerHTML={{
                            __html: modalDemand.content
                        }}
                    />
                </ModalWindow>
            )}
            {isNotShipmentSelected && (
                <ModalWindowCustom
                    footer={<ModalIsNotShipmentFooter />}
                    title="Внимание"
                    cancel={{
                        text: 'Отмена',
                        clickHandler: () => resetSelectedGood()
                    }}>
                    <S.ModalIsNotShipmentContainer>
                        <S.ModalIsNotShipmentP>
                            Для Вашего удобства рекомендуем выбрать аптеку самовывоза или адрес доставки. Это позволит:
                        </S.ModalIsNotShipmentP>
                        <S.ModalIsNotShipmentUl>
                            <S.ModalIsNotShipmentLi>
                                Видеть наличие товаров и цены в конкретной аптеке самовывоза
                            </S.ModalIsNotShipmentLi>
                            <S.ModalIsNotShipmentLi>
                                Определить возможность доставки и ассортимент товаров, доступных по конкретному адресу
                            </S.ModalIsNotShipmentLi>
                        </S.ModalIsNotShipmentUl>
                        <S.ModalIsNotShipmentP>
                            Выбор можно сделать позже (на главной странице или в корзине), но не все товары, добавленные
                            в корзину ранее, могут быть доступны для самовывоза или доставки из-за их отсутствия.
                        </S.ModalIsNotShipmentP>
                    </S.ModalIsNotShipmentContainer>
                </ModalWindowCustom>
            )}
        </React.Fragment>
    )
}

export const BasketModalsMobile = () => {
    const modalDemand = useModalDemand()
    // const closeBasketDemand = useCloseBasketDemand()
    const isNotShipmentSelected = useNotShipmentSelected()
    const resetSelectedGood = useResetSelectedGood()
    const good = useSelectedBasketGood()
    const addBasket = useAddGoodBasket()
    const deleteConfirmationGoodId = useDeleteConfirmationGoodId()
    const applyDelete = useApplyConfirmationDelete()
    const cancelDelete = useCancelConfirmationDelete()
    return (
        <React.Fragment>
            {deleteConfirmationGoodId ? (
                <ModalWindow
                    title="Удаление из корзины"
                    isMobile
                    submit={{
                        text: 'Удалить',
                        clickHandler: applyDelete
                    }}
                    cancel={{
                        text: 'Отмена',
                        clickHandler: cancelDelete
                    }}>
                    Вы действительно хотите удалить выбранный товар из корзины?
                </ModalWindow>
            ) : (
                <React.Fragment />
            )}
            {modalDemand.isShowed && (
                <ModalWindow
                    title="Внимание"
                    isMobile={true}
                    submit={{
                        text: 'Добавить в корзину',
                        clickHandler: () => addBasket(good)
                    }}
                    cancel={{
                        text: 'Отмена',
                        clickHandler: resetSelectedGood
                    }}>
                    <S.BodyModel
                        dangerouslySetInnerHTML={{
                            __html: modalDemand.content
                        }}
                    />
                </ModalWindow>
            )}
            {isNotShipmentSelected && <MessageSelectShipmentMobile />}
        </React.Fragment>
    )
}
